<template>
	<p v-if="items" :class="['usage-bar', { 'usage-bar--flush': flush, 'usage-bar--large': large }]">
		<span v-if="label" class="usage-bar__label">{{ label }}</span>
		<template v-for="(item, index) in items" :key="item.key">
			<span v-if="index" class="usage-bar__sep">·</span>
			<span class="usage-bar__item">
				<span :class="['usage-bar__value', { 'usage-bar__value--empty': item.value === 0 }]">{{ item.value }}</span>
				{{ pluralizeRu(item.value, item.forms) }}
			</span>
		</template>
	</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUsageStore } from '@/stores/usage'
import { pluralizeRu } from '@/utils/pluralizeRu'

// На экранах подписки тот же список нужен без «дней», без верхнего отступа и крупнее:
// счётчик дней там дублирует дату окончания периода в соседней строке.
// Подпись — тоже проп, а не соседний элемент в родителе: вложенный флекс переносит
// строку по своим правилам, и «3» с «песни» разъезжаются по разным строкам.
const props = withDefaults(defineProps<{ showDays?: boolean; flush?: boolean; large?: boolean; label?: string }>(), {
	showDays: true,
	flush: false,
	large: false,
	label: ''
})

const usageStore = useUsageStore()

const items = computed(() => {
	const all = usageStore.items
	if (!all || props.showDays) return all
	return all.filter((item) => item.key !== 'day')
})
</script>

<style lang="scss" scoped>
.usage-bar {
	// Флекс вместо инлайн-текста: пробелы и перенос на узких экранах предсказуемы,
	// разрыв строки возможен только по разделителю, цифра и слово не расходятся.
	@include flex-center;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 10px;
	font: var(--font-caption-strong);
	color: var(--text-brand);
	text-align: center;
	&--flush {
		margin-top: 0;
	}
	&--large {
		font: var(--font-label);
	}
	&__label,
	&__item {
		white-space: nowrap;
	}
	&__value--empty {
		color: var(--status-error);
	}
}
</style>
